// extracted by mini-css-extract-plugin
module.exports = {"debug":"course-card-debug_debug__yoFdh"};